// import React, { useState, useEffect } from "react";
// import { doc, setDoc, getDoc } from "firebase/firestore";
// import { db } from "../firebase";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import SevakForm from "./ttdSeva";

// const generateGroupAccountId = () => {
//   const now = new Date();
//   const yymmdd = now.toISOString().slice(2, 10).replace(/-/g, "");
//   const randomNumber = Math.floor(1000 + Math.random() * 9000);
//   return yymmdd + randomNumber;
// };

// const GroupWithSevakFormNew = () => {
//   const [showGroupForm, setShowGroupForm] = useState(false);
//   const [groupData, setGroupData] = useState(null);
//   const [newGroup, setNewGroup] = useState({
//     groupName: "",
//     leaderName: "",
//     location: "",
//     mobile: "",
//   });
//   const [user, setUser] = useState(null);
//   const [userProfile, setUserProfile] = useState(null);

//   useEffect(() => {
//     const auth = getAuth();
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);
//         const userRef = doc(db, "users", currentUser.uid);
//         const userSnap = await getDoc(userRef);
//         if (userSnap.exists()) {
//           setUserProfile(userSnap.data());
//         }
//       } else {
//         setUser(null);
//         setUserProfile(null);
//       }
//     });

//     return () => unsubscribe();
//   }, []);

//   const handleGroupChange = (e) => {
//     const { name, value } = e.target;
//     setNewGroup((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCreateGroup = async () => {
//     if (!user || !userProfile) {
//       alert("You must be logged in to create a group.");
//       return;
//     }

//     const { role, accountId } = userProfile;
//     if (!["admin", "agent"].includes(role) || !accountId) {
//       alert("Only admins or agents with a valid account ID can create groups.");
//       return;
//     }

//     try {
//       const groupId = generateGroupAccountId();
//       const groupPayload = {
//         ...newGroup,
//         accountId: groupId,
//         createdAt: new Date(),
//         members: [],
//         createdBy: {
//           uid: user.uid,
//           role,
//           accountId,
//         },
//       };

//       const groupRef = doc(db, "sevakGroups", groupId);
//       await setDoc(groupRef, groupPayload);

//       const docSnap = await getDoc(groupRef);
//       setGroupData({ ...docSnap.data(), id: groupRef.id });
//       setShowGroupForm(false);
//     } catch (error) {
//       console.error("Error creating group:", error);
//       alert("Failed to create group");
//     }
//   };

//   const handleSevakAdded = (sevakData) => {
//     setGroupData((prev) => ({
//       ...prev,
//       members: [...(prev?.members || []), sevakData],
//     }));
//   };

//   return (
//     <div className="container mt-4">
//       {!groupData && (
//         <div className="text-center mb-3">
//           {!showGroupForm ? (
//             <button
//               className="btn btn-success"
//               onClick={() => setShowGroupForm(true)}
//             >
//               Add New Group
//             </button>
//           ) : (
//             <div className="card p-3">
//               <h5 className="mb-3">Create New Group</h5>
//               <div className="row g-3">
//                 <div className="col-md-6">
//                   <label className="form-label">Group Name</label>
//                   <input
//                     type="text"
//                     name="groupName"
//                     className="form-control"
//                     value={newGroup.groupName}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Leader Name</label>
//                   <input
//                     type="text"
//                     name="leaderName"
//                     className="form-control"
//                     value={newGroup.leaderName}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Location</label>
//                   <input
//                     type="text"
//                     name="location"
//                     className="form-control"
//                     value={newGroup.location}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Mobile</label>
//                   <input
//                     type="text"
//                     name="mobile"
//                     className="form-control"
//                     value={newGroup.mobile}
//                     onChange={handleGroupChange}
//                     required
//                   />
//                 </div>

//                 <div className="col-md-6">
//   <label className="form-label">Image Folder Path</label>
//   <input
//     type="text"
//     name="imageFolderPath"
//     className="form-control"
//     value={newGroup.imageFolderPath}
//     onChange={handleGroupChange}
//     placeholder="e.g., C:/Users/You/Pictures/sevakGroup1"
//     required
//   />
// </div>



//               </div>
//               <div className="text-center mt-3">
//                 <button className="btn btn-primary" onClick={handleCreateGroup}>
//                   Save Group
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {groupData && (
//         <>
//           <div className="card p-3 mb-4 bg-light">
//             <h5>Group Details</h5>
//             <p>
//               <strong>Group Name:</strong> {groupData.groupName}
//             </p>
//             <p>
//               <strong>Leader:</strong> {groupData.leaderName}
//             </p>
//             <p>
//               <strong>Location:</strong> {groupData.location}
//             </p>
//             <p>
//               <strong>Mobile:</strong> {groupData.mobile}
//             </p>
//             <p>
//               <strong>Group Account ID:</strong> {groupData.accountId}
//             </p>
//             <p>
//               <strong>ImagePath:</strong> {groupData.imageFolderPath}
//             </p>
//           </div>

//           <SevakForm
//             groupId={groupData.id}
//             groupData={groupData}
//             onSevakAdded={handleSevakAdded}
//           />
//         </>
//       )}
//     </div>
//   );
// };

// export default GroupWithSevakFormNew;
// =========================================
// GroupWithSevakFormNew.jsx
import React, { useState, useEffect } from "react";
import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import * as XLSX from "xlsx"; // npm i xlsx
import { db } from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import SevakForm from "./ttdSeva";

const generateGroupAccountId = () => {
    const now = new Date();
    const yymmdd = now.toISOString().slice(2, 10).replace(/-/g, "");
    const randomNumber = Math.floor(1000 + Math.random() * 9000);
    return yymmdd + randomNumber;
};

// ---- Helpers for Bulk Upload (Excel) ----
const DEFAULT_NEAREST_TTD = "SV Temple, Jubilee Hills, Hyderabad, Chennai";

const toTwo = (n) => String(n).padStart(2, "0");

// Format JS Date -> DD/MM/YYYY
const formatDOB_DDMMYYYY = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    return `${toTwo(d.getDate())}/${toTwo(d.getMonth() + 1)}/${d.getFullYear()}`;
};

// Convert Excel serial number -> JS Date
const excelSerialToDate = (serial) => {
    // Excel epoch starts at 1899-12-30
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400; // seconds
    const date_info = new Date(utc_value * 1000);
    const fractional_day = serial - Math.floor(serial) + 1e-7;
    let total_seconds = Math.floor(86400 * fractional_day);
    const seconds = total_seconds % 60;
    total_seconds -= seconds;
    const hours = Math.floor(total_seconds / (60 * 60));
    const minutes = Math.floor(total_seconds / 60) % 60;
    date_info.setHours(hours, minutes, seconds);
    return date_info;
};

const normalizeDOBToDDMMYYYY = (value) => {
    if (value == null || value === "") return "";
    if (typeof value === "number") {
        // Excel serial
        const dt = excelSerialToDate(value);
        return formatDOB_DDMMYYYY(dt);
    }
    if (typeof value === "string") {
        const v = value.trim();
        // YYYY-MM-DD -> DD/MM/YYYY
        if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
            const [y, m, d] = v.split("-");
            return `${d}/${m}/${y}`;
        }
        // Already DD/MM/YYYY
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
            return v;
        }
        // Try to parse generically
        const parsed = new Date(v);
        if (!isNaN(parsed.getTime())) {
            return formatDOB_DDMMYYYY(parsed);
        }
        return "";
    }
    return "";
};

const calcAgeFromDDMMYYYY = (dobDDMMYYYY) => {
    if (!dobDDMMYYYY) return "";
    const [d, m, y] = dobDDMMYYYY.split("/").map((n) => parseInt(n, 10));
    const birth = new Date(y, m - 1, d);
    if (isNaN(birth.getTime())) return "";
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const mDiff = today.getMonth() - birth.getMonth();
    if (mDiff < 0 || (mDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }
    return age;
};

const toBoolean = (val, def = true) => {
    if (val == null || val === "") return def;
    if (typeof val === "boolean") return val;
    const s = String(val).trim().toLowerCase();
    return ["true", "yes", "y", "1"].includes(s);
};

const REQUIRED_HEADERS = [
    "AdharNumber",
    "sevakName",
    "dob", // Accept "YYYY-MM-DD", "DD/MM/YYYY" or Excel date
];

const TEMPLATE_HEADERS = [
    "AdharNumber",
    "sevakName",
    "surName",
    "fatherOrSpouseName",
    "dob", // YYYY-MM-DD (recommended)
    "mobileNo",
    "email",
    "qualification",
    "profession",
    "specialisation",
    "placeOfWork",
    "country",
    "state",
    "district",
    "city",
    "street",
    "doorNo",
    "pincode",
    "nearestTtdTemple",
    "mentallyFit",
    "physicallyFit",
];

const makeTemplateWorkbook = () => {
    const wsData = [
        TEMPLATE_HEADERS,
        [
            "123412341234",
            "Rama",
            "Reddy",
            "Krishna",
            "1990-01-31",
            "9876543210",
            "rama@example.com",
            "B.Tech",
            "Engineer",
            "CSE",
            "ABC Corp",
            "India",
            "Telangana",
            "Hyderabad",
            "Jubilee Hills",
            "Road No 1",
            "1-2-3",
            "500033",
            "SV Temple, Jubilee Hills, Hyderabad, Chennai",
            "TRUE",
            "TRUE",
        ],
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const ws2Data = [
        ["Instructions"],
        [""],
        ["1. Fill the 'dob' as YYYY-MM-DD (or use Excel date)."],
        ["2. 'mentallyFit' and 'physicallyFit' accept TRUE/FALSE, Yes/No, 1/0."],
        [
            "3. Required columns:",
            REQUIRED_HEADERS.join(", "),
        ],
        ["4. Do not include accountId/designation/imageId; they are auto-assigned."],
        ["5. Max 15 members per group (including existing members)."],
    ];
    const ws2 = XLSX.utils.aoa_to_sheet(ws2Data);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sevaks");
    XLSX.utils.book_append_sheet(wb, ws2, "Readme");
    return wb;
};

const GroupWithSevakFormNew = () => {
    const [showGroupForm, setShowGroupForm] = useState(false);
    const [groupData, setGroupData] = useState(null);
    const [newGroup, setNewGroup] = useState({
        groupName: "",
        leaderName: "",
        location: "",
        mobile: "",
        imageFolderPath: "",
    });
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [isImporting, setIsImporting] = useState(false);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                const userRef = doc(db, "users", currentUser.uid);
                const userSnap = await getDoc(userRef);
                if (userSnap.exists()) {
                    setUserProfile(userSnap.data());
                }
            } else {
                setUser(null);
                setUserProfile(null);
            }
        });

        return () => unsubscribe();
    }, []);

    const handleGroupChange = (e) => {
        const { name, value } = e.target;
        setNewGroup((prev) => ({ ...prev, [name]: value }));
    };

    const handleCreateGroup = async () => {
        if (!user || !userProfile) {
            alert("You must be logged in to create a group.");
            return;
        }

        const { role, accountId } = userProfile;
        if (!["admin", "agent"].includes(role) || !accountId) {
            alert("Only admins or agents with a valid account ID can create groups.");
            return;
        }

        try {
            const groupId = generateGroupAccountId();
            const groupPayload = {
                ...newGroup,
                accountId: groupId,
                createdAt: new Date(),
                members: [],
                createdBy: {
                    uid: user.uid,
                    role,
                    accountId,
                },
            };

            const groupRef = doc(db, "sevakGroups", groupId);
            await setDoc(groupRef, groupPayload);

            const docSnap = await getDoc(groupRef);
            setGroupData({ ...docSnap.data(), id: groupRef.id });
            setShowGroupForm(false);
        } catch (error) {
            console.error("Error creating group:", error);
            alert("Failed to create group");
        }
    };

    const handleSevakAdded = (sevakData) => {
        setGroupData((prev) => ({
            ...prev,
            members: [...(prev?.members || []), sevakData],
        }));
    };

    // ---- Bulk Upload (Excel) ----
    const downloadTemplate = () => {
        const wb = makeTemplateWorkbook();
        XLSX.writeFile(wb, "sevak_template.xlsx");
    };

    const validateHeaders = (headers) => {
        const headerSet = new Set(headers.map((h) => String(h || "").trim()));
        for (const req of REQUIRED_HEADERS) {
            if (!headerSet.has(req)) return false;
        }
        return true;
    };

    const handleExcelUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (!groupData?.id) {
            alert("Create or select a group before importing.");
            e.target.value = "";
            return;
        }

        setIsImporting(true);
        try {
            const data = await file.arrayBuffer();
            const wb = XLSX.read(data, { type: "array" });
            const ws = wb.Sheets[wb.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" }); // first row headers
            if (rows.length < 2) {
                alert("The Excel file is empty.");
                e.target.value = "";
                setIsImporting(false);
                return;
            }

            const headers = rows[0].map((h) => String(h).trim());
            if (!validateHeaders(headers)) {
                alert(
                    `Invalid headers. Required: ${REQUIRED_HEADERS.join(", ")}`
                );
                e.target.value = "";
                setIsImporting(false);
                return;
            }

            // Build objects per row
            const bodyRows = rows.slice(1);
            let parsed = bodyRows
                .map((r, idx) => {
                    const obj = {};
                    headers.forEach((h, i) => (obj[h] = r[i]));
                    // Normalize & defaults
                    const dob = normalizeDOBToDDMMYYYY(obj.dob);
                    const age = calcAgeFromDDMMYYYY(dob);

                    return {
                        AdharNumber: String(obj.AdharNumber || "").trim(),
                        sevakName: String(obj.sevakName || "").trim(),
                        surName: String(obj.surName || "").trim(),
                        fatherOrSpouseName: String(obj.fatherOrSpouseName || "").trim(),
                        dob,
                        age,
                        mobileNo: String(obj.mobileNo || "").trim(),
                        email: String(obj.email || "").trim(),
                        qualification: String(obj.qualification || "").trim(),
                        profession: String(obj.profession || "").trim(),
                        specialisation: String(obj.specialisation || "").trim(),
                        placeOfWork: String(obj.placeOfWork || "").trim(),
                        country: String(obj.country || "").trim(),
                        state: String(obj.state || "").trim(),
                        district: String(obj.district || "").trim(),
                        city: String(obj.city || "").trim(),
                        street: String(obj.street || "").trim(),
                        doorNo: String(obj.doorNo || "").trim(),
                        pincode: String(obj.pincode || "").trim(),
                        nearestTtdTemple: String(
                            obj.nearestTtdTemple || DEFAULT_NEAREST_TTD
                        ).trim(),
                        mentallyFit: toBoolean(obj.mentallyFit, true),
                        physicallyFit: toBoolean(obj.physicallyFit, true),

                        // No image fields during bulk import
                        profilePicBase64: "", // you can upload later
                    };
                })
                // Basic validation: required fields
                .filter(
                    (r) =>
                        r.AdharNumber &&
                        r.sevakName &&
                        r.dob // keep only valid rows
                );

            // Load latest group document to ensure fresh members
            const groupRef = doc(db, "sevakGroups", groupData.id);
            const freshSnap = await getDoc(groupRef);
            const fresh = freshSnap.exists() ? freshSnap.data() : groupData;
            const existingMembers = Array.isArray(fresh.members) ? fresh.members : [];
            const currentCount = existingMembers.length;

            // Enforce 15 max
            const remainingSlots = 15 - currentCount;
            if (remainingSlots <= 0) {
                alert("This group already has 15 members.");
                e.target.value = "";
                setIsImporting(false);
                return;
            }

            if (parsed.length > remainingSlots) {
                alert(
                    `Only ${remainingSlots} more members can be added. Truncating the import.`
                );
                parsed = parsed.slice(0, remainingSlots);
            }

            // Remove duplicates by AdharNumber compared to existing members
            const existingAdhars = new Set(
                existingMembers.map((m) => String(m.AdharNumber || "").trim())
            );
            const uniqueParsed = parsed.filter(
                (r) => !existingAdhars.has(r.AdharNumber)
            );

            // Assign accountId, imageId, designation
            const toAdd = uniqueParsed.map((r, i) => {
                const accountId = `${groupData.id}${currentCount + i + 1}`;
                const imageId = `${accountId}_image`;
                const designation =
                    currentCount === 0 && i === 0 ? "teamleader" : "member";
                return {
                    ...r,
                    accountId,
                    imageId,
                    designation,
                };
            });

            if (toAdd.length === 0) {
                alert("No new members to add (maybe all duplicates or invalid rows).");
                e.target.value = "";
                setIsImporting(false);
                return;
            }

            // Persist in one write
            const updatedMembers = [...existingMembers, ...toAdd];
            await updateDoc(groupRef, { members: updatedMembers });

            // Update local state
            setGroupData((prev) => ({
                ...prev,
                members: updatedMembers,
            }));

            alert(
                `Imported ${toAdd.length} member(s) successfully.${parsed.length !== uniqueParsed.length
                    ? ` Skipped ${parsed.length - uniqueParsed.length} duplicate(s).`
                    : ""
                }`
            );
        } catch (err) {
            console.error("Excel import failed:", err);
            alert("Failed to import from Excel. Please check the file and try again.");
        } finally {
            e.target.value = "";
            setIsImporting(false);
        }
    };

    return (
        <div className="container mt-4">
            {!groupData && (
                <div className="text-center mb-3">
                    {!showGroupForm ? (
                        <button
                            className="btn btn-success"
                            onClick={() => setShowGroupForm(true)}
                        >
                            Add New Group
                        </button>
                    ) : (
                        <div className="card p-3">
                            <h5 className="mb-3">Create New Group</h5>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label">Group Name</label>
                                    <input
                                        type="text"
                                        name="groupName"
                                        className="form-control"
                                        value={newGroup.groupName}
                                        onChange={handleGroupChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Leader Name</label>
                                    <input
                                        type="text"
                                        name="leaderName"
                                        className="form-control"
                                        value={newGroup.leaderName}
                                        onChange={handleGroupChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Location</label>
                                    <input
                                        type="text"
                                        name="location"
                                        className="form-control"
                                        value={newGroup.location}
                                        onChange={handleGroupChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Mobile</label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        className="form-control"
                                        value={newGroup.mobile}
                                        onChange={handleGroupChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">Image Folder Path</label>
                                    <input
                                        type="text"
                                        name="imageFolderPath"
                                        className="form-control"
                                        value={newGroup.imageFolderPath}
                                        onChange={handleGroupChange}
                                        placeholder="e.g., C:/Users/You/Pictures/sevakGroup1"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="text-center mt-3">
                                <button className="btn btn-primary" onClick={handleCreateGroup}>
                                    Save Group
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {groupData && (
                <>
                    <div className="card p-3 mb-4 bg-light">
                        <h5>Group Details</h5>
                        <p>
                            <strong>Group Name:</strong> {groupData.groupName}
                        </p>
                        <p>
                            <strong>Leader:</strong> {groupData.leaderName}
                        </p>
                        <p>
                            <strong>Location:</strong> {groupData.location}
                        </p>
                        <p>
                            <strong>Mobile:</strong> {groupData.mobile}
                        </p>
                        <p>
                            <strong>Group Account ID:</strong> {groupData.accountId}
                        </p>
                        <p>
                            <strong>ImagePath:</strong> {groupData.imageFolderPath}
                        </p>
                    </div>

                    {/* ---- Bulk Upload Section ---- */}
                    <div className="card p-3 mb-4">
                        <h6 className="mb-2">Bulk Upload Sevaks (Excel)</h6>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={downloadTemplate}
                            >
                                Download Excel Template
                            </button>
                            <label className="form-label mb-0 ms-2">
                                <span className="me-2">Upload Filled Excel:</span>
                                <input
                                    type="file"
                                    accept=".xlsx,.xls"
                                    onChange={handleExcelUpload}
                                    disabled={isImporting}
                                />
                            </label>
                            {isImporting && <span className="ms-2">Importing...</span>}
                        </div>
                        <small className="text-muted d-block mt-2">
                            Tip: You can upload images later for each member. This upload will
                            only save member details.
                        </small>
                    </div>

                    <SevakForm
                        groupId={groupData.id}
                        groupData={groupData}
                        onSevakAdded={handleSevakAdded}
                    />
                </>
            )}
        </div>
    );
};

export default GroupWithSevakFormNew;